module.exports = __webpack_public_path__ + "9b3798211178dae3352dcde80ffb9c3a.png";